import { create } from 'zustand'

export const useUIStore = create((set) => ({
  // Sidebar
  sidebarCollapsed: false,
  toggleSidebar: () => set(s => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  // Stats (populated by Dashboard)
  totalWords: 0,
  setTotalWords: (n) => set({ totalWords: n }),

  // Global loading overlay
  globalLoading: false,
  setGlobalLoading: (v) => set({ globalLoading: v }),

  // Command palette (Phase 2)
  commandPaletteOpen: false,
  openCommandPalette:  () => set({ commandPaletteOpen: true }),
  closeCommandPalette: () => set({ commandPaletteOpen: false }),

  // Active modal
  activeModal: null,
  openModal:  (id) => set({ activeModal: id }),
  closeModal: ()   => set({ activeModal: null }),
}))
